var _path, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisableGyro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m350.769-185.386-42.153-42.153 77.693-78.924q-122.231-16.231-204.269-64.038Q100.001-418.308 100.001-480q0-73.769 110.115-126.884Q320.231-659.999 480-659.999t269.884 53.115Q859.999-553.769 859.999-480q0 52.769-60.538 96.768-60.539 44-159.461 66.461V-378q77-20 118.5-49.5T800-480q0-33.154-85.5-76.577Q629-600 480-600t-234.5 43.423Q160-513.154 160-480q0 26.308 58.693 60.769 58.693 34.462 156.539 50.308l-66.616-66.616 42.153-42.153 146.152 146.153-146.152 146.153Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    stroke: "currentColor",
    x1: 120,
    y1: -120,
    x2: 840,
    y2: -840,
    strokeWidth: 60,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableGyro);
export default __webpack_public_path__ + "static/media/disable-gyro.3b90ab92aa567b69f21f78c9f552951b.svg";
export { ForwardRef as ReactComponent };